import React from "react";
import AssessmentAdminIntroMeetingRow from "./AssessmentAdminIntroMeetingRow";
import AssessmentAdminExtraDateRows from "./AssessmentAdminExtraDateRows";
import AssessmentAdminSystemManagedDateRows from "./AssessmentAdminSystemManagedDateRows";

/**
 * Intro meeting, then optional middle rows (children), then final-draft +
 * system-managed date rows. Owns the new-code JSX delta for these fields.
 */
export default function AssessmentAdminDatesSection({
  vqa,
  updateActive,
  control,
  dateFormat,
  watch,
  setValue,
  showIntroMeetingDatePicker,
  introMeetingReadKind,
  children,
}) {
  return (
    <>
      <AssessmentAdminIntroMeetingRow
        hide={vqa == null}
        updateActive={updateActive}
        showIntroMeetingDatePicker={showIntroMeetingDatePicker}
        introMeetingReadKind={introMeetingReadKind}
        introMeetingNotRequiredChecked={watch("introMeetingNotRequired")}
        onIntroMeetingNotRequiredChange={(checked) => {
          setValue("introMeetingNotRequired", checked, {
            shouldValidate: false,
          });
        }}
        introMeetingDate={vqa?.intro_meeting_complete_date}
        control={control}
        dateFormat={dateFormat}
      />
      {children}
      <AssessmentAdminExtraDateRows
        section="main"
        vqa={vqa}
        updateActive={updateActive}
        control={control}
        dateFormat={dateFormat}
        hideWhenNoVqa
      />
      <AssessmentAdminSystemManagedDateRows
        vqa={vqa}
        updateActive={updateActive}
        control={control}
        dateFormat={dateFormat}
        hideWhenNoVqa
      />
    </>
  );
}
